import React, { FC, useState } from "react";
import { Table, Typography } from "antd";
import type { ColumnsType } from "antd/es/table";
import {
  DataOrderproductskuNewOrder,
  OrderDataOrderproductskuNewOrder,
} from "services/interface";
import { formatDateWithTime } from "utils/dateFormat";
import { numberFormat } from "utils/nuberFormat";

const paymentStatus = (status: string | null) => {
  if (status === "confirm") {
    return "ชำระเงินแล้ว";
  } else if (status === "pending") {
    return "รอชำระเงิน";
  } else {
    return "-";
  }
};

const columns: ColumnsType<OrderDataOrderproductskuNewOrder> = [
  {
    title: "หมายเลขคำสั่งซื้อ",
    dataIndex: "order_code",
    fixed: "left",
    width: 200,
    sorter: (a, b) => a.order_code.localeCompare(b.order_code),
    render: (_text) => {
      return <Typography.Paragraph>{_text}</Typography.Paragraph>;
    },
  },
  {
    title: "สินค้า",
    dataIndex: "product_name",
    width: 250,
    fixed: "left",
    sorter: (a, b) => a.product_name.localeCompare(b.product_name),
    render: (_text, record) => {
      return (
        <div style={{ display: "flex", flexDirection: "row" }}>
          <img
            src={record.image_url}
            alt={record.image_url}
            style={{ width: 40, height: 40, marginRight: 10 }}
          />
          <div
            style={{
              maxWidth: "150px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            <Typography.Paragraph style={{ marginBottom: 0 }}>
              {record.product_name}
            </Typography.Paragraph>
            <Typography.Paragraph style={{ fontSize: "10px", marginBottom: 0 }}>
              {record.sku_description}
            </Typography.Paragraph>
          </div>
        </div>
      );
    },
  },

  {
    title: "รหัสสินค้า",
    dataIndex: "product_code",
    width: 150,
    sorter: (a, b) => {
      if (a.product_code !== undefined && b.product_code !== undefined) {
        return a.product_code.localeCompare(b.product_code);
      } else {
        return 0;
      }
    },
    render: (text) => {
      return <div>{text ? text : "-"}</div>;
    },
  },

  {
    title: "จำนวน",
    dataIndex: "qty",
    width: 100,
    sorter: (a, b) => a.qty - b.qty,
  },

  {
    title: "วันที่ทำการสั่งซื้อ",
    dataIndex: "order_date",
    width: 150,
    sorter: (a, b) => {
      const dateA = new Date(a.order_date).getTime();
      const dateB = new Date(b.order_date).getTime();
      return dateA - dateB;
    },
    render: (_text) => {
      return <div>{formatDateWithTime(_text)}</div>;
    },
  },
  {
    title: "ชื่อผู้รับบริการ",
    dataIndex: "address_name",
    width: 200,
    sorter: (a, b) => a.address_name.localeCompare(b.address_name),
    render: (text) => {
      return <div>{text ? text : "-"}</div>;
    },
  },
  {
    title: "เบอร์โทรศัพท์",
    dataIndex: "address_telephone",
    width: 150,
    sorter: (a, b) => a.address_telephone.localeCompare(b.address_telephone),
    render: (text) => {
      return <div>{text ? text : "-"}</div>;
    },
  },
  {
    title: "สถานะการชำระเงิน",
    dataIndex: "payment_status",
    width: 150,
    sorter: (a, b) => {
      if (a.payment_status !== null && b.payment_status !== null) {
        return a.payment_status.localeCompare(b.payment_status);
      } else {
        return 0;
      }
    },
    render: (text, record) => {
      if (record.item_status === "cancel") {
        return <div style={{ color: "#FF0000" }}>ยกเลิก</div>;
      }
      return <div>{paymentStatus(text)}</div>;
    },
  },
  {
    title: "Operator ID",
    dataIndex: "operator_id",
    //sorter: (a, b) => a.operator_id.localeCompare(b.operator_id),
    width: 200,
    render: (text) => {
      return <div>{text ? text : "-"}</div>;
    },
  },
  {
    title: "Merchant ID",
    dataIndex: "merchant_id",
    //sorter: (a, b) => a.merchant_id.localeCompare(b.merchant_id),
    width: 200,
    render: (text) => {
      return <div>{text ? text : "-"}</div>;
    },
  },
  {
    title: "ตัวแทน",
    dataIndex: "agent_name",
    //sorter: (a, b) => a.agent_name.localeCompare(b.agent_name),
    width: 200,
    render: (text) => {
      return <div>{text ? text : "-"}</div>;
    },
  },
  {
    title: "รหัสตัวแทน",
    dataIndex: "agent_code",
    //sorter: (a, b) => a.agent_name.localeCompare(b.agent_name),
    width: 200,
    render: (text) => {
      return <div>{text ? text : "-"}</div>;
    },
  },
  {
    title: "สังกัด",
    dataIndex: "factory_main_name",
    //sorter: (a, b) => a.factory_main_name.localeCompare(b.factory_main_name),
    width: 250,
    render: (text) => {
      return <div>{text ? text : "-"}</div>;
    },
  },
  {
    title: "แผนก",
    dataIndex: "department_name",
    //sorter: (a, b) => a.department_name.localeCompare(b.department_name),
    width: 250,
    render: (text) => {
      return <div>{text ? text : "-"}</div>;
    },
  },


];
interface TableProductListProps {
  data: DataOrderproductskuNewOrder | undefined;
  limit: number;
  setLimit: (limit: number) => void;
  offset: number;
  setOffset: (offset: number) => void;
  isLoading: boolean;
}

const TableProductList: FC<TableProductListProps> = ({ data, limit, setLimit, offset, setOffset, isLoading }) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <div>
      {/* rowSelection={rowSelection} */}
      <Table columns={columns}
        dataSource={data?.order_data}
        loading={isLoading}
        scroll={{
          x: 1500,
          y: 500,
        }}
        pagination={{
          pageSize: limit,
          total: parseInt(data?.total_record as string),
          onChange: (page, pageSize) => {
            setOffset(pageSize! * (page! - 1));
            setLimit(pageSize!);
          },
        }}
      />
    </div>
  );
};

export default TableProductList;
